import Admin from 'hive-admin';

import PageArchiveTable from '../../components/PageArchiveTable';

import {
  ADMIN as FILTERS_ADMIN,
} from './filters';

import {
  ADMIN as COLUMNS_ADMIN,
} from './columns';

import {
  ADMIN as FIELDS_ADMIN,
} from './fields';

// const { viewerIsNotAdmin } = tests;

export default [
  ...Admin.compileFromLibrary(['GroupResource', {
    title: 'Companies',
    path: '/shipping/companies',
    // icon: 'car',
    singleLoadUrl: '/shippingcompanies/:id',
    archiveLoadUrl: '/shippingcompanies',
    archiveConfig: {
      title: 'Companies',
      label: 'Companies',
      // icon: 'car',
      createButtonPath: '/shipping/companies/create',
      // hidden: [viewerIsNotAdmin],
      loadUrl: '/shippingcompanies',
      getColumns: (props, columns) => {
        const { viewer } = props;
        if (viewer?.role === 'ADMIN') {
          return PageArchiveTable.defaultProps.getColumns(props, columns);
        }
        return PageArchiveTable.defaultProps.getColumns(
          props,
          (columns || props.columns).filter(
            column => column.path !== 'store.name'
          ),
        );
      },
    },
    singleConfig: {
      hidden: true,
      alias: '/shipping/companies',
      backButtonPaths: ['/shipping/companies'],
      loadUrl: '/shippingcompanies/:id',
      duplicateLoadUrl: '/shippingcompanies/:duplicate',
    },
    singleEditConfig: {
      actions: [
        ['ActionSave', {
          handleSuccess: (data, props) => props.reload(),
        }],
        ['ActionDelete'],
        ['Action', {
            name: 'duplicate',
            title: 'Duplicate',
            ghost: true,
            onClick: (props) => props.history.push(
            `/shipping/companies/create?duplicate=${
              props.data ? props.data._id : null
            }`
          ),
          }],
      ],
    },
    redirect: [
      ['redirect.unauthorized'],
      // [
      //   'redirect.checkViewer',
      //   'role', '!==', 'ADMIN',
      //   '/store',
      // ],
    ],
    columns: COLUMNS_ADMIN,
    filters: FILTERS_ADMIN,
    fields: FIELDS_ADMIN,
  }]).pages,
];
